module.exports = __webpack_public_path__ + "static/media/Hardware-collage.87c701f6.png";